export const ORGANIZATION_COLUMN_KEYS = {
  EXTERNAL_ID: "externalId",
  NAME: "name",
  ADDRESS: "address",
  PRODUCTS: "products",
  USER_COUNT: "userCount",
  LAST_LOGIN_AT: "lastLoginAt",
  CREATED_AT: "createdAt",
} as const;

export const DEFAULT_VISIBLE_COLUMNS: Record<string, boolean> = {
  [ORGANIZATION_COLUMN_KEYS.EXTERNAL_ID]: true,
  [ORGANIZATION_COLUMN_KEYS.NAME]: true,
  [ORGANIZATION_COLUMN_KEYS.ADDRESS]: true,
  [ORGANIZATION_COLUMN_KEYS.PRODUCTS]: true,
  [ORGANIZATION_COLUMN_KEYS.USER_COUNT]: true,
  [ORGANIZATION_COLUMN_KEYS.LAST_LOGIN_AT]: true,
  [ORGANIZATION_COLUMN_KEYS.CREATED_AT]: true,
};

export const COLUMN_DISPLAY_ITEMS = [
  { key: ORGANIZATION_COLUMN_KEYS.EXTERNAL_ID, label: "組織ID", isAlwaysShowing: true },
  { key: ORGANIZATION_COLUMN_KEYS.NAME, label: "組織名", isAlwaysShowing: true },
  { key: ORGANIZATION_COLUMN_KEYS.ADDRESS, label: "住所" },
  { key: ORGANIZATION_COLUMN_KEYS.PRODUCTS, label: "契約サービス" },
  { key: ORGANIZATION_COLUMN_KEYS.USER_COUNT, label: "登録ユーザー数" },
  { key: ORGANIZATION_COLUMN_KEYS.LAST_LOGIN_AT, label: "最終ログイン" },
  { key: ORGANIZATION_COLUMN_KEYS.CREATED_AT, label: "登録日" },
];

export const ORGANIZATION_STATUS = {
  ACTIVE: "active",
  ARCHIVED: "archived",
  DELETED: "deleted",
} as const;

export const ORGANIZATION_TABS = [
  { label: "利用中", value: ORGANIZATION_STATUS.ACTIVE },
  { label: "アーカイブ済み", value: ORGANIZATION_STATUS.ARCHIVED },
  { label: "データ消去済み", value: ORGANIZATION_STATUS.DELETED },
];
